/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityDiscountReportUpdatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityDiscountReportUpdatePage
);
